// extracted by mini-css-extract-plugin
export default {"JobworkPartyList":"JobworkPartyList_JobworkPartyList__aZLHe"};